import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgress = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("mask", {
		id: "progress-mask",
		children: /* @__PURE__ */ _jsx("path", {
			className: "progress-path",
			d: "M 50 96 a 46 46 0 0 1 0 -92 46 46 0 0 1 0 92",
			pathLength: 100
		})
	}) }), /* @__PURE__ */ _jsx("foreignObject", {
		mask: "url(#progress-mask)",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("div", {
			className: "progress-gradient",
			xmlns: "http://www.w3.org/1999/xhtml"
		})
	})]
});
export default SvgProgress;
